import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import queryClient from "api/queryClient.ts";
import { getFormQueryOptions } from "api/TenantSlug/Form/queryOptions.ts";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { isAxiosErrorOfStatus } from "utils/isAxiosErrorOfStatus.ts";

const GET_FORM_QUERY_FILTERS = {
    filter: { include: "formPages,formFields,formStructure,category,labels" },
};

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/design/_layout/form/_layout/$formId/_layout"
)({
    component: () => <Outlet />,
    loader: async ({ params }) => {
        const { formId, tenantSlug } = params;

        let breadcrumb = formId;

        try {
            const { form } = await queryClient.ensureQueryData(getFormQueryOptions(formId, GET_FORM_QUERY_FILTERS));
            breadcrumb = form?.name;
        } catch (error) {
            if (isAxiosErrorOfStatus(error, 404)) {
                throw redirect({
                    to: "/$tenantSlug/tool/design/form",
                    params: { tenantSlug },
                });
            }
            console.error(error);
        }

        return {
            breadcrumb,
        };
    },
    pendingComponent: () => <QueryState isLoading={true} isError={false} />,
    errorComponent: () => <QueryState isLoading={false} isError={true} errorKey="errors.loading_form" />,
});
